// extracted by mini-css-extract-plugin
export default {"container":"AppSection_container__50Cki","right_cont":"AppSection_right_cont__VppG+","left_cont":"AppSection_left_cont__grICo"};